import { render, staticRenderFns } from "./404.vue?vue&type=template&id=6b3aeb0e&"
import script from "./404.vue?vue&type=script&lang=ts&"
export * from "./404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3aeb0e')) {
      api.createRecord('6b3aeb0e', component.options)
    } else {
      api.reload('6b3aeb0e', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=6b3aeb0e&", function () {
      api.rerender('6b3aeb0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/404.vue"
export default component.exports